module.exports = __webpack_public_path__ + "img/Especificaciones Propuesta diseño P2H-09.5ff9dfb1.png";